export const realtorOptionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  minWidth: 0,
  width: '100%',
};

export const realtorOptionBadgesStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 0.5,
};
